import { SET_QUANTITY, SET_SCHEDULE, SET_SCREEN, TOGGLE_CATEGORY, TOGGLE_STAGE } from "./reducer";

export default function setSchedule(dispatch, newScheduleID: number | null) {
  dispatch({
    type: SET_SCHEDULE,
    payload: newScheduleID,
  });
}

export function toggleStage(dispatch, stageID: number) {
  dispatch({
    type: TOGGLE_STAGE,
    payload: stageID,
  })
}

export function toggleCategory(dispatch, categoryID: number) {
  dispatch({
    type: TOGGLE_CATEGORY,
    payload: categoryID,
  })
}

export function setQuantity(dispatch, categoryID: number, feeQuantity: number) {
  dispatch({
    type: SET_QUANTITY,
    payload: {
      ID: categoryID,
      quantity: feeQuantity,
    },
  })
}

export function setScreen(dispatch, increment: number) {
  dispatch({
    type: SET_SCREEN,
    payload: increment,
  })
}
